import React, { useState } from 'react';
import arrowup from "../assets/images/p_arrow-rt.png";
import { motion } from "framer-motion";

export default function FormC() {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
    });

    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [id]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        console.log(formData);
    };

    return (
        <div className='px-[8%] py-[3%] grid md:grid-cols-2 gap-y-5 gap-x-20'>

            {/* Form Section */}
            <motion.div
                initial={{ opacity: 0, x: -50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: false }}
            >
                <form onSubmit={handleSubmit} className=''>

                    {/* Header animation */}
                    <motion.header
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: false }}
                    >
                        <h3 className='text-[1.7rem] font-extrabold leading-none text-[var(--primary-color)]'>
                            Fill In your <br />
                            <span className='text-[var(--second-primary-color)]'>Information</span>
                        </h3>
                        <p className='text-[.9rem] text-[#002455] pt-2'>
                            and we'll be in touch as soon as we can!
                        </p>
                    </motion.header>

                    {/* Input Fields with stagger effect */}
                    <div className="flex flex-col text-[#555D68] pt-6 text-[.9rem] space-y-2">
                        {["name", "email", "phone", "message"].map((field, index) => (
                            <motion.input
                                key={field}
                                type="text"
                                id={field}
                                value={formData[field]}
                                onChange={handleChange}
                                className="border-b-2 border-gray-200 w-full focus:outline-none focus:border-blue-500 bg-transparent py-2"
                                placeholder={
                                    field === "message"
                                        ? "Let us know how we can help"
                                        : `Enter your ${field}`
                                }
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ delay: index * 0.1, duration: 0.4 }}
                                viewport={{ once: false }}
                            />
                        ))}

                        {/* Submit Button */}
                        <motion.button
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.95 }}
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.5, duration: 0.4 }}
                            viewport={{ once: false }}
                            type="submit"
                        >
                            <p className='flex text-[#555D68] text-[.9rem] font-bold leading-[2] px-4 py-6'>
                                <i className="flex justify-center items-center mr-6 h-[25px] mt-1 w-[25px] rounded-full bg-[var(--primary-color)]">
                                    <img src={arrowup} alt="arrow" />
                                </i>
                                <span className='text-[#002455]'>Submit</span>
                            </p>
                        </motion.button>
                    </div>
                </form>
            </motion.div>

            {/* Map iframe animation */}
            <motion.div
                initial={{ opacity: 0, x: 50 }}
                whileInView={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.6 }}
                viewport={{ once: false }}
            >
                <iframe
                    title="Gandaria Ventures Limited Location Map"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3953.8626167790962!2d8.554243573598072!3d7.697889208406049!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x105a7f000d4abefd%3A0xcd8810f3776dfe6b!2sGandaria%20Ventures%20Limited!5e0!3m2!1sen!2sng!4v1743756794045!5m2!1sen!2sng"
                    style={{ border: 0 }}
                    loading="lazy"
                    allowFullScreen=""
                    referrerPolicy="no-referrer-when-downgrade"
                    className='w-[100%] h-[100%] rounded-lg'
                ></iframe>
            </motion.div>
        </div>
    );
}
